import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  BackofficeKnowledgeItemsResponseDataSchema,
  DataResponse,
  GetBackofficeKnowledgeItemsSchema,
} from "schema"
import { z } from "zod"

type Query = Omit<z.input<typeof GetBackofficeKnowledgeItemsSchema>, "companyId"> & {
  companyId: string | undefined
}
type Response = DataResponse<z.infer<typeof BackofficeKnowledgeItemsResponseDataSchema>>

export const getBackofficeKnowledgeItemsQuery = ({ query }: { query: Query }) => {
  return queryOptions({
    placeholderData: () => undefined,
    queryKey: ["backofficeKnowledgeItems", query],
    enabled: Boolean(query.companyId),
    queryFn: async ({ signal }) => {
      const { data } = await axios.get<Response>("/backoffice/knowledge/items", {
        params: query,
        signal,
      })
      return data.data
    },
  })
}
